var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button-custom",class:{
    'block': _vm.isBlock, 
    'white-btn': _vm.isWhite, 
    'is-catering': _vm.isCatering
    },on:{"click":function($event){return _vm.goTo(_vm.link)}}},[(_vm.isWhite)?_c('div',{staticClass:"button-text",class:_vm.isWhite ? 'white-text' : ''},[_vm._v(_vm._s(_vm.text)+" ")]):_c('div',{staticClass:"button-text",class:_vm.isCatering ? 'white-text' : ''},[_vm._v(_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }